import React, { FC } from 'react'
import { Box, makeStyles, TableCell, TableRow, Theme, Typography } from '@material-ui/core'
import { Maybe } from '../../graphql'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: 0,
    borderBottom: 'none',
    height: 'min-content',
  },
  divider: {
    width: '100%',
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
    height: theme.spacing(3),
  },
  line: {
    flex: 1,
    height: 1,
    backgroundColor: theme.palette.divider,
  },
}))

export const TableDivider: FC<{ dividerText: Maybe<string> | undefined }> = ({ dividerText }) => {
  const classes = useStyles()

  return (
    <TableRow>
      <TableCell colSpan={9} className={classes.container}>
        <Box className={classes.divider}>
          <Box className={classes.line} />

          <Typography variant="subtitle2" color="textSecondary">
            {dividerText}:
          </Typography>

          <Box className={classes.line} />
        </Box>
      </TableCell>
    </TableRow>
  )
}
